import { createFileRoute } from '@tanstack/react-router';
import { ReceiptsRedirectRoute } from './-route-wrappers';

// `/settings/receipts` redirects to Billing history.
//
// Only the bare path is owned here — `/settings/receipts/:id` is a server-rendered Stripe receipt
// served elsewhere, so this exact route must not match it.
export const Route = createFileRoute('/_authenticated/settings/receipts')({
  component: ReceiptsRedirectRoute,
});
